<template>
  <div>
    <LayoutTitle :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
      <FormLayout
        v-if="item.formPropertyList.length"
        ref="projectForm" 
        :readOnly="readOnly"
        :model="personalInfo"
        :list="generatePage(index)"
        @on-upload-success="upload"
        @on-change-all="person"
        @on-change-tree="checkPerson">
      </FormLayout>
    </LayoutTitle>
    <!-- <LayoutTitle
      :title="item.groupName" 
      v-for="(item, index) in dynamicList" 
      :key="item.groupId"
      :showBtn="!readOnly && item.groupType != 1"
      :btnText="item.btnText"
      @on-click="addTableData(item)"
    >
      <FormLayout
        v-if="item.groupType == 1"
        ref="projectForm" 
        :readOnly="readOnly"
        :model="personalInfo"
        :list="generatePage(index)"
        @on-change="changeHandler"
        @on-upload-success="upload"
        @on-change-tree="checkPerson">
      </FormLayout>
      <DragTable
        v-if="item.groupType != 1"
        class="iv-m-t-24"
        noUrl
        noSearch 
        :showSelect="false"
        :showEdit="!readOnly"
        :showDelete="!readOnly"
        ref="DragTable"
        :showPage="false"
        :immediateForce="true" 
        :columns="generatePage(index)" 
        :tableData="honorData">
      </DragTable>
    </LayoutTitle> -->
    <LayoutTitle title="近三年获得荣誉" :showBtn="!readOnly" btnText="新增荣誉" @on-click="addHonor" v-if="show">
      <DragTable
        class="iv-m-t-24"
        noUrl
        noSearch 
        :showSelect="false"
        :showEdit="!readOnly"
        :showDelete="!readOnly"
        ref="DragTable"
        :showPage="false"
        :immediateForce="true" 
        :columns="honorColumn" 
        :tableData="honorData">
      </DragTable>
    </LayoutTitle>
    <LayoutTitle class="iv-p-b-24" title="简历信息" :showBtn="!readOnly" btnText="新增简历" @on-click="addResume" v-if="show">
      <DragTable
        class="iv-m-t-24"
        noUrl
        noSearch 
        :showSelect="false"
        :showEdit="!readOnly"
        :showDelete="!readOnly"
        ref="DragTable1" 
        :showPage="false"
        :immediateForce="true" 
        :columns="resumeColumn" 
        :tableData="resumeData">
      </DragTable>
    </LayoutTitle>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'
import { cloneDeep } from 'lodash'
import generateList from './generate-form'
import honorColumn from './honorColumn.js'
import resumeColumn from './resumeColumn.js'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import LayoutTitle from '@/components/layout/layout-title'
import { submitIndividualSignUp, getIndividualSignUp, editIndividualSignUp } from '../../interface'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      showPerson: false,
      personalInfo: {},
      defaultInfo: {
        userName: this.$decode(sessionStorage.getItem('userName')),
        userId: this.$decode(sessionStorage.getItem('userId'))
      },
      honorData: [],
      resumeData: [],
      groupId: '',
      dictMap: {},
      photoSrc: '',
      show: true,
      readOnly: false,
      dynamicList: []
    }
  },
  async created () {
    this.idMap = JSON.parse(sessionStorage.getItem('idMap'))
    this.nameMap = JSON.parse(sessionStorage.getItem('nameMap'))
    this.readOnly = this.$decode(this.$route.query.type) == 'see'
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.orgId = this.$decode(sessionStorage.getItem(this.idMap[this.bizLineCode]))
    //三八红旗手
    this.honorColumn = honorColumn.call(this)
    this.resumeColumn = resumeColumn.call(this)
    //获取信息
    await this.getCodeTable('GB4762')
  },
  provide () {
    return {
      saveItem: this.saveItem,
      deleteItem: this.deleteItem,
      removeAdd: this.removeAdd
    }
  },
  inject: ['getApplicationObjectId'],
  methods: {
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //重置表单校验
    resetFields () {
      if (Array.isArray(this.$refs.projectForm)) {
        this.$refs.projectForm.every(ref => {
          ref.resetFields()
        })
      } else {
        this.$refs.projectForm.resetFields()
      }
    },
    //获取个人信息
    async getPersonInfo (params, readOnly) {
      if (params) {
        // this.readOnly = !params.isReportState
        getIndividualSignUp({signUpId: params.signUpId, orgId: params.orgId}).then(({data}) => {
          if (params.quickFill) {
            data.isCancel = '0'
          }
          let isCancel = data.isCancel
          this.readOnly = isCancel == '1'
          //把特殊字符& 转义, 查询回来之后再替换回去
          data.contributionsAndResults = data.contributionsAndResults || ''
          data.mainDeeds = data.mainDeeds || ''
          data.deedsIntroduction = data.deedsIntroduction || ''
          data.contributionsAndResults = data.contributionsAndResults.replace(/%26/g, '&')
          data.mainDeeds = data.mainDeeds.replace(/%26/g, '&')
          data.deedsIntroduction = data.deedsIntroduction.replace(/%26/g, '&')
          this.personalInfo = cloneDeep({ ...this.defaultInfo, ...data })
          this.honorData = data.rewardsList && data.rewardsList.map(item => ({
            ...item,
            $type: 'honor',
            rewardDate: timeFormat(item.rewardDate)
          }))
          this.resumeData = data.resumeInfoList && data.resumeInfoList.map(item => ({
            ...item,
            $type: 'resume',
            startDate: timeFormat(item.startDate),
            endDate: timeFormat(item.endDate)
          }))
          if (data.photo != '') {
            this.photoSrc = `api-uum/file/downloadFile?fileId=${data.photo}&access_token=${sessionStorage.getItem('token')}`
          }
          //设置附件
          if (this.personalInfo.attachmentGroupId) {
            this.groupId = this.personalInfo.attachmentGroupId
            this.getActivityFiles(this.groupId).then(data => {
              this.$set(this.personalInfo, 'uploadFile', data)
            })
          } else {
            this.groupId = this.getUuid()
          }
          this.$emit('on-request', data)
          //动态表单
          this.dynamicList = this.list
          // this.dynamicList = this.list.map(item => {
          //   return {
          //     ...item,
          //     btnText: item.groupName.indexOf('荣誉') != -1 ? '新增荣誉' : '新增简历'
          //   }
          // })
          this.transferDataType()
        })
      } else {
        await this.getUserInfoFromChildSystem()
        this.readOnly = false
        this.personalInfo = cloneDeep(this.defaultInfo)
        this.computedAge()
        this.changeHandler(this.personalInfo.inDeptDate)
        this.groupId = this.getUuid()
        //动态表单
        this.dynamicList = this.list
        // this.dynamicList = this.list.map(item => {
        //   return {
        //     ...item,
        //     btnText: item.groupName.indexOf('荣誉') != -1 ? '新增荣誉' : '新增简历'
        //   }
        // })
        this.transferDataType()
      }
    },
    //从子系统获取人员信息
    getUserInfoFromChildSystem () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/byUserIdPink',
          method: 'get',
          data: {
            bizLineCode: this.bizLineCode || 'YWX01',
          }
        }).then(({data}) => {
          const { nationality, nation, photo, education, joinPartyDate, email, workPost, hrDuty, birthday, idCardNum, political, uumUserInfo} = data.data
          this.$set(this.defaultInfo, 'nationality', nationality || '') 
          this.$set(this.defaultInfo, 'nation', (nation || '') + '')
          this.$set(this.defaultInfo, 'joinPartyDate', timeFormat(joinPartyDate))
          this.$set(this.defaultInfo, 'education', (education || '') + '')
          this.$set(this.defaultInfo, 'email', email || '')
          this.$set(this.defaultInfo, 'workPost', (workPost || '') + '')
          this.$set(this.defaultInfo, 'hrDuty', (hrDuty || '') + '')
          this.$set(this.defaultInfo, 'partyOrgName', this.$decode(sessionStorage.getItem('orgName')))
          this.$set(this.defaultInfo, 'unionOrgName', this.$decode(sessionStorage.getItem('fullName')))
          this.$set(this.defaultInfo, 'unionOrgId', this.$decode(sessionStorage.getItem('fullId')))
          this.$set(this.defaultInfo, 'companyOrgName', this.$decode(sessionStorage.getItem('orgPath')))
          this.$set(this.defaultInfo, 'companyOrgId', '')
          //从uum取得
          // let political = ''
          // this.dictMap['GB4762'].forEach(val => {
          //   if (val.label == this.$decode(sessionStorage.getItem('userPolitical'))) {
          //     political = val.value
          //   }
          // })
          this.$set(this.defaultInfo, 'political', political)
          const gender = this.$decode(sessionStorage.getItem('userGender'))
          this.$set(this.defaultInfo, 'gender',  gender ? (gender == '女' ? '2' : '1') : '')
          this.$set(this.defaultInfo, 'birthday', timeFormat(birthday))
          this.$set(this.defaultInfo, 'phone', this.$decode(sessionStorage.getItem('userPhone')))
          this.$set(this.defaultInfo, 'employeeNumber', this.$decode(sessionStorage.getItem('userCode')))
          this.$set(this.defaultInfo, 'idCardNum', idCardNum || this.$decode(sessionStorage.getItem('idCardNum')))
          //this.computedAge()
          if (photo) {
            this.$set(this.defaultInfo, 'photo', photo || '')
            this.photoSrc = `api-uum/file/downloadFile?fileId=${photo}&access_token=${sessionStorage.getItem('token')}`
          }
          //从uumUserInfo获取
          this.$set(this.defaultInfo, 'email', uumUserInfo.age || '')
          this.$set(this.defaultInfo, 'email', uumUserInfo.email || '')
          this.$set(this.defaultInfo, 'nation', uumUserInfo.nationalityStr || '')
          this.$set(this.defaultInfo, 'nationality', uumUserInfo.nationality || '')
          this.$set(this.defaultInfo, 'education', uumUserInfo.highestEducation || '')
          this.$set(this.defaultInfo, 'band', uumUserInfo.bBandId || '')
          this.$set(this.defaultInfo, 'hrDuty', uumUserInfo.dutyCode || '')
          this.$set(this.defaultInfo, 'workPost', uumUserInfo.jobCode || '')
          this.$set(this.defaultInfo, 'companyOrgName', uumUserInfo.orgPath || '')
          this.$set(this.defaultInfo, 'workPostDate', uumUserInfo.posBegDate)
          this.$set(this.defaultInfo, 'inDeptDate', uumUserInfo.work4Company)
          this.changeHandler(uumUserInfo.work4Company)
          resolve()
        })
      })
    },
    person (val, key) {
      if(key== 'userName') {
        this.$set(this.personalInfo, 'political', val[0].political)
        // 注释掉的字段从uum中获取 lxr
        // this.$set(this.personalInfo, 'gender', val[0].gender.toString())
        // this.$set(this.personalInfo, 'nationality', val[0].nationality)
        // this.$set(this.personalInfo, 'nation', val[0].nation)
        this.$set(this.personalInfo, 'birthday', timeFormat(val[0].birthday))
        // this.changeHandler(val[0].inDeptDate)
        this.$set(this.personalInfo, 'joinPartyDate', timeFormat(val[0].joinPartyDate))
        // this.$set(this.personalInfo, 'inDeptDate', timeFormat(val[0].inDeptDate))
        this.$set(this.personalInfo, 'employeeNumber', val[0].userCode)
        this.$set(this.personalInfo, 'idCardNum', val[0].idCardNum)
        // this.$set(this.personalInfo, 'education', val[0].education)
        // this.$set(this.personalInfo, 'email', val[0].email)
        this.$set(this.personalInfo, 'phone', val[0].phone)
        // this.$set(this.personalInfo, 'band', val[0].expandFieldm)
        this.$set(this.personalInfo, 'partyOrgName', val[0].orgName)
        // this.$set(this.personalInfo, 'companyOrgName', val[0].expandFieldaf)
        // this.$set(this.personalInfo, 'workPost', val[0].expandFieldao)
        // this.$set(this.personalInfo, 'workPostDate', val[0].jobDate)
        // this.$set(this.personalInfo, 'hrDuty', val[0].hrDuty)
        this.computedAge()
        this.getUserInfoFromChildSystem()
      }
    },
    //计算年龄和司龄
    computedAge () {
      // const date = this.defaultInfo.idCardNum.substring(6, 14).replace(/(\d{4})(\d{2})(\d{2})/, function (str, $1, $2, $3) {
      //   return `${$1}/${$2}/${$3}`
      // })
      const date = this.personalInfo.idCardNum.substring(6, 14).replace(/(\d{4})(\d{2})(\d{2})/, function (str, $1, $2, $3) {
        return `${$1}/${$2}/${$3}`
      })
      const distance = new Date().getTime() - new Date(date).getTime()
      const age = Math.floor(distance / 1000 / 60 / 60 / 24 / 365)
      // this.$set(this.defaultInfo, 'age', age)
      this.$set(this.personalInfo, 'age', age)
    },
    //选择入司时间后 计算司龄
    changeHandler (val) {
      val = new Date(val)
      const distance = new Date().getTime() - val.getTime()
      const sourceAge = distance / 1000 / 60 / 60 / 24 / 365
      this.$set(this.personalInfo, 'workingAge', Math.floor(sourceAge))
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.personalInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.personalInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker' && !(value instanceof Date)) {
            this.$set(this.personalInfo, val.propertyCode, value ? new Date(value) : '')
          }
        })
      })
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => {
        if (ref.validateify) {
          return ref.validateify()
        } else {
          return null
        }
      }).filter(v => v)
      return req
    },
    //将date对象格式化
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submitPersonInfo (recommendInfo) {
      const applicationObjectId = this.getApplicationObjectId()
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$emit('on-close', 'valid')
          this.$Message.error('表单校验失败')
          return
        }
        const isContinue = this.validateTable()
        if (!isContinue) {
          this.$emit('on-close', 'valid')
          return
        }
        const requestMethod = recommendInfo.signUpId ? editIndividualSignUp : submitIndividualSignUp
        //把特殊字符& 转义, 查询回来之后再替换回去
        const arr = cloneDeep(this.personalInfo)
        arr.contributionsAndResults = arr.contributionsAndResults || ''
        arr.mainDeeds = arr.mainDeeds || ''
        arr.deedsIntroduction = arr.deedsIntroduction || ''
        arr.contributionsAndResults = arr.contributionsAndResults.replace(/&/g, encodeURIComponent('&')) || ''
        arr.mainDeeds = arr.mainDeeds.replace(/&/g, encodeURIComponent('&')) || ''
        arr.deedsIntroduction = arr.deedsIntroduction.replace(/&/g, encodeURIComponent('&')) || ''
        if (arr.inDeptDate) {
          arr.inDeptDate = timeFormat(arr.inDeptDate)
        }
        if (arr.workPostDate) {
          arr.workPostDate = timeFormat(arr.workPostDate)
        }
        const params = this.dateFormat({
          ...recommendInfo,
          ...arr,
          attachmentGroupId: this.groupId,
          applicationObjectId: applicationObjectId,
          userName: Array.isArray(arr.userName) ? arr.userName[0].userName : arr.userName,
          userId: Array.isArray(arr.userName) ? arr.userName[0].userId : arr.userId
        })
        if (this.honorData.length) {
          params.rewardsList = this.honorData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.honorData.length && params.rewardsList) {
          delete params.rewardsList
        }
        if (this.resumeData.length) {
          params.resumeInfoList = this.resumeData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.resumeData.length && params.resumeInfoList) {
          delete params.resumeInfoList
        }
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          if (!recommendInfo.signUpId) {
            let type = 'addType' //修改
            this.$emit('on-request', {
              ...recommendInfo,
              signUpId: data.signUpId
            }, type) //修改
          } else {
            this.$emit('on-close')
          }
        }).catch(() => {
          this.$emit('on-close', 'valid')
        })
      })
    },
    validateTable () {
      let isContinue = true
      if (this.honorData.length) {
        isContinue = this.honorData.every(item => !item.errorQueue)
        if (!isContinue) {
          this.$Message.warning('荣誉记录必填项未填写')
          return isContinue
        }
      }
      if (this.resumeData.length) {
        isContinue = this.resumeData.every(item => !item.errorQueue)
        if (!isContinue) {
          this.$Message.warning('简历信息必填项未填写')
          return isContinue
        }
      }
      return isContinue
    },
    //上传头像
    upload (file) {
      this.personalInfo.photo = file?.response?.data?.fileId || ''
    },
    //点击取消
    removeAdd (index, item) {
      if (item._add) {
        const data = item.$type == 'honor' ? 'honorData' : 'resumeData'
        this[data].splice(index, 1)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
        }
      }
    },
    //表格校验
    validateColumns (item) {
      let isContinue = true
      item.errorQueue = item.errorQueue || {}
      Object.keys(item).forEach(val => {
        if (val == 'isEdit' || val.indexOf('_') != -1) {
          item.errorQueue[val] = false
        } else if (!item[val]) {
          item.errorQueue[val] = true
          isContinue = false
        } else {
          item.errorQueue[val] = false
        }
      })
      return isContinue
    },
    //保存
    saveItem (item) {
      const index = item._index
      const isContinue = this.validateColumns(item)
      const data = item.$type == 'honor' ? 'honorData' : 'resumeData'
      if (!isContinue) {
        this.$set(this[data], index, item)
        return Promise.reject(item)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
          if (i.indexOf('_') != -1) {
            delete item[i]
          }
        }
        delete item.errorQueue
        item.isEdit = false
        this[data].splice(index, 1, item)
        return Promise.resolve({item, showMessage: 'message'})
      }
    },
    //删除
    deleteItem (item) {
      if (item.$type == 'honor') {
        this.honorData.splice(item._index, 1)
      }
      if (item.$type == 'resume') {
        this.resumeData.splice(item._index, 1)
      }
      return Promise.resolve()
    },
    //选择工会、单位
    checkPerson (data, key) {
      if (!data.length) return
      if (key == 'unionOrgName') {
        this.personalInfo.unionOrgId = data[0].id
      }
    },
    //新增表头事件
    addTableData (item) {
      if (item.btnText == '新增荣誉') {
        this.addHonor()
      } else {
        this.addResume()
      }
    },
    //新增荣誉
    addHonor () {
      this.honorData.unshift({
        isEdit: true,
        $type: 'honor',
        errorQueue: {},
        awardOrganization: '',
        rewardTitle: '',
        rewardDate: '',
        _add: true
      })
    },
    //新增简历
    addResume () {
      this.resumeData.unshift({
        isEdit: true,
        $type: 'resume',
        errorQueue: {},
        startDate: '',
        endDate: '',
        unitName: '',
        postName: '',
        _add: true
      })
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    DragTable,
    FormLayout,
    LayoutTitle
  }
}
</script>
